import * as React from 'react';
import WrapperField from './Field.js';
import List from './List.js';
import useForm from './useForm.js';
import Form from './Form.js';
import { FormProvider } from './FormContext.js';
import '../../rc-util/es/warning.js';
import useWatch from './useWatch.js';
var InternalForm = /*#__PURE__*/React.forwardRef(Form);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = WrapperField;
RefForm.List = List;
RefForm.useForm = useForm;
RefForm.useWatch = useWatch;
export { WrapperField as Field, FormProvider, List, RefForm as default, useForm, useWatch };
//# sourceMappingURL=index.js.map
